export default __webpack_public_path__ + "static/media/export-icon.dce2d942.svg";